import { useTranslation } from 'react-i18next'
import { graphql, useMutation } from 'react-relay'
import { store } from '../../store'
import { AppTypes } from '../../reducers/app.reducer'
import formatError from '../errorFormatter'
import ConfigurationService from '../../service/ConfigurationService'
import { convertUnit } from '@src/service/coins/coins'
import { UserProp } from '@src/stores/auth/user'
import { getUserPreference } from '@src/stores/auth/preferences'
import { WithdrawViewSubmitWithdrawMutation } from './__generated__/WithdrawViewSubmitWithdrawMutation.graphql'
import React from 'react'

// Add the mutation query at the bottom of the file
export const submitWithdrawMutation = graphql`
  mutation WithdrawViewSubmitWithdrawMutation($input: SubmitWithdrawInput!) {
    submitWithdraw(input: $input) {
      withdraw {
        amount
        currency
        isProcessed
        txid
        isAuthenticated
        address
        insertedAt
        uuid
        meta
      }
    }
  }
`

interface WithdrawConfirmPopupProps {
  unit: string
  amount: string
  currency: string
  virtualId: number
  address: string
  network?: string
  memo?: string
  setPopup: (popup: React.ReactNode) => void
  clearForm: () => void
  setIsLoadingSubmission: (loading: boolean) => void
  onSubmit?: () => void
}

export const WithdrawConfirmPopup = ({
  unit,
  amount,
  currency,
  virtualId,
  address,
  network,
  memo,
  setPopup,
  clearForm,
  setIsLoadingSubmission,
  onSubmit,
}) => {
  const { t } = useTranslation()
  const showNotification = (status, text) =>
    store.dispatch({ type: AppTypes.SHOW_NOTIFICATION, notification: { status: status, text: text } })

  const [commit] = useMutation<WithdrawViewSubmitWithdrawMutation>(submitWithdrawMutation)

  const HandleClick = () => {
    const c = ConfigurationService.instance.getCurrency(currency)

    const format = getUserPreference(('unit_' + c.short) as UserProp, (value) => value || c.format)
    const preparedAmout = convertUnit(+amount, c.m_unit, format, c.s_unit)

    setIsLoadingSubmission(true)
    commit({
      variables: { input: { amount: preparedAmout, currency, virtualId, address, network, memo } },

      onCompleted: (data) => {
        setPopup(
          <div className="TransactionCompletePopup">
            <div className="title">{t('wallet.withdrawConfirmPopup.transactionComplete', 'transaction complete')}</div>
          </div>
        )
        clearForm()
        setIsLoadingSubmission(false)

        if (onSubmit) {
          onSubmit()
        }
      },
      onError: (e) => {
        // toast.error(e)
        showNotification('error', formatError(e)[0])
        setIsLoadingSubmission(false)
      },
    })
  }

  return (
    <div className="WithdrawConfirmPopup">
      <div className="title">
        {t('wallet.withdrawConfirmPopup.requestToWithdraw', 'You requested to withdraw')}
        <br />
        {amount}
        {currency === 'BTC' ? unit : currency}
      </div>
      {address && (
        <div className="address">
          <div className="label">{t('wallet.withdrawConfirmPopup.toThisAddress', 'to this adress')}</div>
          <div>{address}</div>
        </div>
      )}
      <button type="button" onClick={() => HandleClick()}>
        {t('wallet.withdrawConfirmPopup.approve', 'Approve')}
      </button>
    </div>
  )
}

export default WithdrawConfirmPopup
